var React = require('react');

function StatusPassedOutline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 32C7.16 32 0 24.84 0 16S7.16 0 16 0s16 7.16 16 16-7.16 16-16 16zm0-2c7.73 0 14-6.27 14-14S23.73 2 16 2 2 8.27 2 16s6.27 14 14 14zm7.3-20.7l1.4 1.4L13 22.4l-5.7-5.7 1.4-1.4 4.3 4.3L23.3 9.3z","fillRule":"evenodd"}));
}

StatusPassedOutline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = StatusPassedOutline;

StatusPassedOutline.default = StatusPassedOutline;
